import { useAnswersheetQuery } from "../../../Redux/Apis/userExamApi";
import { fa_number } from "../../../utils/Persian";
import Loading from "../../../Layouts/Loading";
import { safeParseHtml } from "../../../utils/safeParseHtml";

function isAnswerCorrect(userAnswer: string = '', correctAnswer: string = ''): boolean {
  const trimmedUser = userAnswer.trim();
  const trimmedCorrect = correctAnswer.trim();

  // اگر کاما داشته باشه: ترتیب مهمه → فقط برابری مستقیم
  if (trimmedCorrect.includes(',')) {
    return trimmedUser === trimmedCorrect;
  }

  // اگر فقط از حروف A تا E باشه → ترتیب مهم نیست (مثلاً برای پاسخ‌های چندگزینه‌ای)
  const onlyLetters = /^[a-zA-Z]+$/;
  if (onlyLetters.test(trimmedCorrect) && onlyLetters.test(trimmedUser)) {
    const normalize = (str: string) => str.toUpperCase().split('').sort().join('');
    return normalize(trimmedUser) === normalize(trimmedCorrect);
  }

  // برای سایر حالت‌ها (اعداد، کسری، پاراگراف،...) → برابری دقیق
  return trimmedUser === trimmedCorrect;
}

function Answersheet({userExamId,close}:any) {
    const {
        isLoading,
        data,
        isSuccess,
    } = useAnswersheetQuery(+userExamId)

    return ( 
        <div
            dir="ltr"
            className="position-fixed border border-danger-subtle border-3 pt-2 rounded bg-white shadow"
            style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxHeight: "90vh",
                width: "min(960px, 95vw)",
                overflowY: "auto",
                zIndex: 1050,
            }}
        >
            <h6 className="text-center mt-2">پاسخنامه سوالات</h6>
            <hr />
            {isLoading && <Loading />}
            {isSuccess && data && (
                <>
                    <div className="px-3 px-md-4 pb-3">
                        <div className="py-3 border rounded mb-3">
                            <div className="container text-center">
                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-2 g-lg-5 text-light">
                                    <div className="col">
                                        <div className="d-flex justify-content-center align-items-center p-3 rounded bg-danger">
                                            <div className="fw-bold">Total:</div>
                                            <div className="me-2 fs-2 fw-bold">{fa_number(+data.stat.Total.correct)}</div>
                                            <div className="fs-5 fw-bold mt-1">/{fa_number(+data.stat.Total.all)}</div>
                                        </div>
                                    </div>
                                    <div className="col position-relative">
                                        <div className="d-flex justify-content-center align-items-center p-3 rounded bg-danger-subtle text-danger">
                                            <div className="fw-bold py-2">Verbal:</div>
                                            <div className="me-2 fs-2 fw-bold">{fa_number(+data.stat.Verbal.correct)}</div>
                                            <div className="fs-5 fw-bold mt-1">/{fa_number(+data.stat.Verbal.all)}</div>
                                        </div>
                                        {data.stat.Verbal.pers && (
                                            <div className="position-absolute top-0 start-10 translate-middle badge rounded-pill text-bg-danger z-3">
                                                <div className="d-flex justify-content-center align-items-center p-1">
                                                    <div className="fw-bold py-2">Percentile:</div>
                                                    <div className="me-2 fs-5 fw-bold">{fa_number(+data.stat.Verbal.pers)}</div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col position-relative">
                                        <div className="d-flex justify-content-center align-items-center p-3 rounded bg-danger-subtle text-danger">
                                            <div className="fw-bold py-2">Quant:</div>
                                            <div className="me-2 fs-2 fw-bold">{fa_number(+data.stat.Quant.correct)}</div>
                                            <div className="fs-5 fw-bold mt-1">/{fa_number(+data.stat.Quant.all)}</div>
                                        </div>
                                        {data.stat.Quant.pers && (
                                            <div className="position-absolute top-0 start-10 translate-middle badge rounded-pill text-bg-danger z-3">
                                                <div className="d-flex justify-content-center align-items-center p-1">
                                                    <div className="fw-bold py-2">Percentile:</div>
                                                    <div className="me-2 fs-5 fw-bold">{fa_number(+data.stat.Quant.pers)}</div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col">
                                        <div className="d-flex justify-content-center align-items-center p-3 rounded bg-danger-subtle text-danger">
                                            <div className="fw-bold py-2">Writing:</div>
                                            <div className="me-2 fs-2 fw-bold">{fa_number(+data.stat.Writing.correct)}</div>
                                            <div className="fs-5 fw-bold mt-1">/{fa_number(+data.stat.Writing.all)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="table-responsive"
                            style={{ maxHeight: "60vh", overflowY: "auto" }}
                        >
                            <table className="table table-sm table-bordered mb-0">
                                <thead>
                                    <tr className="table-danger">
                                        <th scope="col" className="bg-danger text-center text-white">
                                            #
                                        </th>
                                        <th scope="col" className="bg-danger text-white">
                                            Question
                                        </th>
                                        <th scope="col" className="bg-danger text-center text-white">
                                            Answer
                                        </th>
                                        <th scope="col" className="bg-danger text-center text-white">
                                            Correct Answer
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {data.answers.map((row, index) => (
                                        <tr
                                            key={index}
                                            className={
                                                isAnswerCorrect(
                                                    row.UserAnswers?.[0]?.answer,
                                                    row?.answersheet
                                                )
                                                    ? "table-success"
                                                    : "table-danger"
                                            }
                                        >
                                            <th scope="row" className="text-center">
                                                {index + 1}
                                            </th>
                                            <td
                                                style={{
                                                    display: "block",
                                                    maxHeight: "60px",
                                                    overflow: "hidden",
                                                    padding: "10px",
                                                    lineHeight: "1.2",
                                                }}
                                            >
                                                {safeParseHtml(row.question)}
                                            </td>
                                            <td className="text-center">
                                                {row?.UserAnswers[0]?.answer}
                                            </td>
                                            <td className="text-center">{row?.answersheet}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}
            <hr />
            <button
                type="button"
                onClick={() => close(false)}
                className="btn btn-outline-primary me-4 mb-3 px-5"
            >
                بستن
            </button>
        </div>
    );
}

export default Answersheet;
